import javascript from "../images/marquee/javascript.png";
import node from "../images/marquee/node.png";
import reactjs from "../images/marquee/reactjs.png";
import tailwind from "../images/marquee/tailwind.png";
import typescript from "../images/marquee/typescript.png";
import html from "../images/marquee/html.png";
import css from "../images/marquee/css.png";
import postgres from "../images/marquee/postgres.png";
import sql from "../images/marquee/sql.png";
const Marquee = () => {
  const images = [
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
    javascript,
    node,
    reactjs,
    tailwind,
    typescript,
    html,
    css,
    postgres,
    sql,
  ];
  return (
    <div class="mt-16 relative overflow-hidden w-full">
      <p className="text-lg text-center text-[#9CA3AF] tracking-wider">
        My Superpowers
      </p>
      <div className="marquee-shade mt-8">
        <div className="scrolling-wrapper flex animate-scroll">
          {images.map((e, i) => (
            <img
              src={e}
              alt="skill"
              className="flex-shrink-0 mx-10 h-14"
              key={i}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default Marquee;
